export const pinLength = 6;
export const mnemonicEntropy = 256;
export const mnemonicLength = Math.ceil(mnemonicEntropy / 11); // 24 words. https://learnmeabitcoin.com/technical/mnemonic
export const pinkIterations = 100;
export const hpinkIterations = 100;
export const pinkKdf = 'Pbkdf2';
export const keyAlgorithm = 'Secp256k1';
export const svIv = new Uint8Array(12).fill(0);
export const ncDerivationPath = "m/0'/0'/0'";
